import { Button, Checkbox, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";

import image1 from "../../../../../../../assets/images/owner-statement.jpeg";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function SendRenewalOffer({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" colon={false} onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Send Renewal Offer" />
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="gotoTenantPage" valuePropName="checked">
              <Checkbox>go to the tenant page in SayEagle</Checkbox>
            </Form.Item>
            <Form.Item
              label="2"
              name="prepareRenewalOffer"
              valuePropName="checked"
            >
              <Checkbox>
                click prepare renewal offer on right side. - verify tenant info
                is correct in SayEagle.
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="3"
              name="useSayEagleLease"
              valuePropName="checked"
            >
              <Checkbox>select "use SayEagle lease"</Checkbox>
            </Form.Item>
            <Form.Item
              label="4"
              name="selectRenewalOffer"
              valuePropName="checked"
            >
              <Checkbox>make sure to select Renewal offer letter</Checkbox>
            </Form.Item>
            <Form.Item label="5" name="prorateCharges" valuePropName="checked">
              <Checkbox>make sure to prorate charges if needed</Checkbox>
            </Form.Item>
            <Form.Item label="6" name="selectDeadline" valuePropName="checked">
              <Checkbox>
                select a deadline to respond but DO NOT SELECT A DEFAULT LEASE
                AMOUNT
              </Checkbox>
            </Form.Item>
            <Form.Item label="7" name="useRenewalLease" valuePropName="checked">
              <Checkbox>
                use renewal lease IT HAS ALL NEEDED INFO NO NEED FOR OTHER
                ATTACHMENTS
              </Checkbox>
            </Form.Item>
            <Form.Item label="8" name="additionalFees" valuePropName="checked">
              <Checkbox>
                BE SURE TO ENTER THE ADDITIONAL FEES SUCH AS UTILITIES/PETS/TBP
                - remember tenant benefit package - new is now $13 per month and
                THE SN INSURANCE FEE IS $11.95 per month. These must be entered
                on all new leases
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="9"
              name="emailRenewalOfferLetter"
              valuePropName="checked"
            >
              <Checkbox>
                make sure to email the Renewal offer letter (picture below)
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="10"
              name="securityDeposit"
              valuePropName="checked"
            >
              <Checkbox>
                Enter a $50 security deposit waiver admin fee if they are
                signing up for the SD waiver program. Also enter the charge for
                the monthly fee that they will owe for the program. see below
              </Checkbox>
            </Form.Item>
            <Form.Item
              label="11"
              name="3PercMonthRentpaidPerMonth"
              valuePropName="checked"
            >
              <Checkbox>800-850 = 3% of monthly rent paid per month</Checkbox>
            </Form.Item>
            <Form.Item
              label="12"
              name="5PercMonthRentpaidPerMonth"
              valuePropName="checked"
            >
              <Checkbox>750-799 = 4% of monthly rent paid per month</Checkbox>
            </Form.Item>
            <Form.Item
              label="13"
              name="6PercMonthRentpaidPerMonth"
              valuePropName="checked"
            >
              <Checkbox>700-749 = 6% of monthly rent paid per month</Checkbox>
            </Form.Item>
            <Form.Item
              label="14"
              name="9PercMonthRentpaidPerMonth"
              valuePropName="checked"
            >
              <Checkbox>650-699 = 9% of monthly rent paid per month</Checkbox>
            </Form.Item>
            <Form.Item
              label="15"
              name="10PercMonthRentpaidPerMonth"
              valuePropName="checked"
            >
              <Checkbox>600-649 = 10% of monthly rent paid per month</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <h2 className="red-heading">
              DO NOT SET THE RENT TO DEFAULT TO ANY AMOUNT! WE WILL NEED TO
              MANUALLY ADJUST THIS NOW!
            </h2>
          </Col>
          <Col span={24}>
            <h2 className="green-heading">
              Set due date of the renewal to 2 weeks from now or less depending
              on situation.
            </h2>
          </Col>
          <Col span={24}>
            <img className="owner-statement-img" src={image1} alt="image1" />
          </Col>
          <Col span={24}>
            <img className="owner-statement-img" src={image1} alt="image1" />
          </Col>
          <Col span={24}>
            <img className="owner-statement-img" src={image1} alt="image1" />
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default SendRenewalOffer;
